/*
 * File: DataModel.js
 * Project: mp-mobile-app
 *
 * Created by Jen on 06/27/2018
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Patient vitals data model
 */
import { types } from "mobx-state-tree";

const VitalsDataModel = {
  date: types.optional(types.maybeNull(types.Date), () => new Date()),
  height: types.maybe(types.number),
  feet: types.maybe(types.number),
  inches: types.maybe(types.number),
  weight: types.maybe(types.number),
  systolic: types.maybe(types.number),
  diastolic: types.maybe(types.number),
  heartRate: types.maybe(types.number),
  temperature: types.maybe(types.number),
  sp02: types.maybe(types.number),
  respiratoryRate: types.maybe(types.number),
  headCircumference: types.maybe(types.number)
};

export default VitalsDataModel;
